"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromLineBreak = void 0;
var createHtmlFromLineBreak = function () {
    return "<br/><span>&#8203;</span>";
};
exports.createHtmlFromLineBreak = createHtmlFromLineBreak;
